import React from 'react';
import Backdrop from "./Backdrop";
import classes from './ModalResponsive.module.scss';

const ModalResponsive = (props) => {
    return (
        <div className={classes.Modal_container}>
            <Backdrop show={true}/>
            <p className={classes.Title}>
                {/* Sebelumnya yang <h2> bikin error di console log, 
                kurang bagus juga untuk SEO, jangan pakai <b> biar teks ini ga terbaca SEO */}
                <span><strong>Hello, thank you for visiting our websites.</strong></span><br></br>
                <span><strong>We are currently working on the mobile view version.</strong></span><br></br>
                <span><strong>Please kindly change your mobile browser settings to desktop site view.</strong></span>
            </p>
        </div>
    );
}

export default ModalResponsive;